var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('v-data-table',{staticClass:"elevation-1 w-100 proposta",attrs:{"headers":_vm.headersValores,"items":_vm.itemValores,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.investimentoTotal",fn:function({ item }){return [_vm._v("\n          "+_vm._s(item.investimentoTotal &&
            item.investimentoTotal.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }))+"\n        ")]}},{key:"item.contrapartidaSebrae",fn:function({ item }){return [_vm._v("\n          "+_vm._s(item.contrapartidaSebrae &&
            item.contrapartidaSebrae.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }))+"\n        ")]}},{key:"item.investimentoMunicipal",fn:function({ item }){return [_vm._v("\n          "+_vm._s(item.investimentoMunicipal &&
            item.investimentoMunicipal.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }))+"\n        ")]}}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }